import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'jobManagement',
  initialState: {
    // Job Category
    jobCategoryListLoading: false,
    jobCategoryList: [],
    jobCategoryListPaginationData: {},
    updateJobCategory: false,

    // Job Sub Category
    jobSubCategoryListLoading: false,
    jobSubCategoryList: [],
    jobSubCategoryListPaginationData: {},
    updateJobSubCategory: false,

    // Job Tag
    jobTagListLoading: false,
    jobTagList: [],
    jobTagListPaginationData: {},
    jobTagDetails: null,
    updateJobTag: false,

    // ================= PROVIDER JOB LIST =================
    jobProviderListLoading: false,
    jobProviderList: [],
    jobProviderPagination: {},

    // ================= JOB SEEKER APPLIED =================
    jobSeekerAppliedListLoading: false,
    jobSeekerAppliedList: [],
    jobSeekerAppliedPagination: {},

    // ================= STORE JOB LIST =================
    storeJobListLoading: false,
    storeJobList: [],
    storeJobPagination: {},
    jobDetailsLoading: false,
    jobDetails: null,

    // ================= STORE JOB APPLICATION LIST =================
    storeJobApplicationListLoading: false,
    storeJobApplicationList: [],
    storeJobApplicationPagination: {},

    // ================= JOB SEEKER RESUME =================

    jobSeekerResumeListLoading: false,
    jobSeekerResumeList: [],
    jobSeekerResumePagination: {},

    jobSeekerResumeDetailsLoading: false,
    jobSeekerResumeDetails: null,

    // UI states
    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    // ✅ Job Category List
    jobCategoryListApiData: (state) => {
      state.jobCategoryListLoading = true
    },
    jobCategoryListApiSuccess: (state, { payload }) => {
      state.jobCategoryListLoading = false
      state.jobCategoryList = payload?.payload?.data
      state.jobCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    jobCategoryListApiFailed: (state, { payload }) => {
      state.jobCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Add Job Category
    addJobCategoryApiData: (state) => {
      state.jobCategoryListLoading = true
      state.updateJobCategory = false
      state.modalOpen = false
    },
    addJobCategoryApiSuccess: (state, { payload }) => {
      state.updateJobCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.jobCategoryListLoading = false
    },
    addJobCategoryApiFailed: (state, { payload }) => {
      state.updateJobCategory = false
      state.jobCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Update Job Category
    updateJobCategoryApiData: (state, { payload }) => {
      state.updateJobCategory = false
      state.jobCategoryList = state.jobCategoryList?.map((item) =>
        item?.id === payload?.id ? { ...item, ...payload } : item,
      )
    },
    updateJobCategoryApiSuccess: (state, { payload }) => {
      state.updateJobCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateJobCategoryApiFailed: (state, { payload }) => {
      state.updateJobCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Delete Job Category
    deleteJobCategoryApiData: (state, { payload }) => {
      state.jobCategoryList = state.jobCategoryList?.filter((item) => item.id !== payload?.id)
      state.updateJobCategory = false
    },
    deleteJobCategoryApiSuccess: (state, { payload }) => {
      state.updateJobCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteJobCategoryApiFailed: (state, { payload }) => {
      state.updateJobCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Job Sub Category List
    jobSubCategoryListApiData: (state) => {
      state.jobSubCategoryListLoading = true
    },
    jobSubCategoryListApiSuccess: (state, { payload }) => {
      state.jobSubCategoryListLoading = false
      state.jobSubCategoryList = payload?.payload?.data
      state.jobSubCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    jobSubCategoryListApiFailed: (state, { payload }) => {
      state.jobSubCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Add Job Sub Category
    addJobSubCategoryApiData: (state) => {
      state.jobSubCategoryListLoading = true
      state.updateJobSubCategory = false
      state.modalOpen = false
    },
    addJobSubCategoryApiSuccess: (state, { payload }) => {
      state.updateJobSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.jobSubCategoryListLoading = false
    },
    addJobSubCategoryApiFailed: (state, { payload }) => {
      state.updateJobSubCategory = false
      state.jobSubCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Update Job Sub Category
    updateJobSubCategoryApiData: (state, { payload }) => {
      state.updateJobSubCategory = false
      state.jobSubCategoryList = state.jobSubCategoryList?.map((item) =>
        item?.id === payload?.id ? { ...item, ...payload } : item,
      )
    },
    updateJobSubCategoryApiSuccess: (state, { payload }) => {
      state.updateJobSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateJobSubCategoryApiFailed: (state, { payload }) => {
      state.updateJobSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Delete Job Sub Category
    deleteJobSubCategoryApiData: (state, { payload }) => {
      state.jobSubCategoryList = state.jobSubCategoryList?.filter((item) => item.id !== payload?.id)
      state.updateJobSubCategory = false
    },
    deleteJobSubCategoryApiSuccess: (state, { payload }) => {
      state.updateJobSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteJobSubCategoryApiFailed: (state, { payload }) => {
      state.updateJobSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Job Tag List

    jobTagListApiData: (state) => {
      state.jobTagListLoading = true
    },
    jobTagListApiSuccess: (state, { payload }) => {
      state.jobTagListLoading = false
      state.jobTagList = payload?.payload?.data
      state.jobTagListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    jobTagListApiFailed: (state, { payload }) => {
      state.jobTagListLoading = false
      state.ApiError = payload?.message
    },

    // ✅ Get Job Tag By Id
    jobTagByIdApiData: (state) => {
      state.jobTagListLoading = true
    },
    jobTagByIdApiSuccess: (state, { payload }) => {
      state.jobTagListLoading = false
      state.jobTagDetails = payload?.payload
    },
    jobTagByIdApiFailed: (state, { payload }) => {
      state.jobTagListLoading = false
      state.ApiError = payload?.message
    },

    // ✅ Add Job Tag
    addJobTagApiData: (state) => {
      state.jobTagListLoading = true
      state.updateJobTag = false
      state.modalOpen = false
    },
    addJobTagApiSuccess: (state, { payload }) => {
      state.updateJobTag = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.jobTagListLoading = false
      // Add new tag to the list
      if (payload?.payload?.data) {
        state.jobTagList.unshift(payload.payload.data)
      }
    },
    addJobTagApiFailed: (state, { payload }) => {
      state.updateJobTag = false
      state.jobTagListLoading = false
      state.ApiError = payload?.message
    },

    // ✅ Update Job Tag
    updateJobTagApiData: (state) => {
      state.jobTagListLoading = true
      state.updateJobTag = false
    },
    updateJobTagApiSuccess: (state, { payload }) => {
      state.updateJobTag = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.jobTagListLoading = false
      // Update tag in the list
      if (payload?.payload?.data) {
        const updatedTag = payload.payload.data
        state.jobTagList = state.jobTagList.map((tag) =>
          tag.id === updatedTag.id ? updatedTag : tag,
        )
      }
    },
    updateJobTagApiFailed: (state, { payload }) => {
      state.updateJobTag = false
      state.jobTagListLoading = false
      state.ApiError = payload?.message
    },

    // ✅ Delete Job Tag
    deleteJobTagApiData: (state, { payload }) => {
      state.jobTagList = state.jobTagList?.filter((item) => item.id !== payload?.tag_id)
      state.updateJobTag = false
    },
    deleteJobTagApiSuccess: (state, { payload }) => {
      state.updateJobTag = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteJobTagApiFailed: (state, { payload }) => {
      state.updateJobTag = false
      state.ApiError = payload?.message
    },

    // ✅ Active/Inactive Job Tag
    activeInactiveJobTagListApiData: (state) => {
      state.jobTagListLoading = true
      state.updateJobTag = false
    },
    activeInactiveJobTagListApiSuccess: (state, { payload }) => {
      state.jobTagListLoading = false
      state.updateJobTag = true
      state.modalOpen = true
      state.ApiError = payload?.payload

      // Update the tag status in the list immediately for better UX
      if (payload?.payload?.data) {
        const updatedTag = payload.payload.data
        state.jobTagList = state.jobTagList.map((tag) =>
          tag.id === updatedTag.id ? { ...tag, is_active: updatedTag.is_active } : tag,
        )
      }
    },
    activeInactiveJobTagListApiFailed: (state, { payload }) => {
      state.jobTagListLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= PROVIDER JOB LIST =================
    jobProviderListApiData: (state) => {
      state.jobProviderListLoading = true
    },

    jobProviderListApiSuccess: (state, { payload }) => {
      state.jobProviderListLoading = false
      state.jobProviderList = payload?.payload?.data || []
      state.jobProviderPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        pages: payload?.payload?.pages,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },

    jobProviderListApiFailed: (state, { payload }) => {
      state.jobProviderListLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= JOB SEEKER APPLIED =================
    jobSeekerAppliedListApiData: (state) => {
      state.jobSeekerAppliedListLoading = true
    },

    jobSeekerAppliedListApiSuccess: (state, { payload }) => {
      state.jobSeekerAppliedListLoading = false
      state.jobSeekerAppliedList = payload?.payload?.data || []
      state.jobSeekerAppliedPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        pages: payload?.payload?.pages,
      }
    },

    jobSeekerAppliedListApiFailed: (state, { payload }) => {
      state.jobSeekerAppliedListLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },
    // ================= STORE JOB LIST =================
    storeJobListApiData: (state) => {
      state.storeJobListLoading = true
    },

    storeJobListApiSuccess: (state, { payload }) => {
      state.storeJobListLoading = false
      state.storeJobList = payload?.payload?.data || []
      state.storeJobPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
      }
    },

    storeJobListApiFailed: (state, { payload }) => {
      state.storeJobListLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },

    // ================= STORE JOB APPLICATION LIST =================
    storeJobApplicationListApiData: (state) => {
      state.storeJobApplicationListLoading = true
    },

    storeJobApplicationListApiSuccess: (state, { payload }) => {
      state.storeJobApplicationListLoading = false
      state.storeJobApplicationList = payload?.payload?.data || []
      state.storeJobApplicationPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        pages: payload?.payload?.pages,
      }
    },

    storeJobApplicationListApiFailed: (state, { payload }) => {
      state.storeJobApplicationListLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Active / Inactive Job Category
    activeInactiveJobCategoryApiData: (state) => {
      state.jobCategoryListLoading = true
      state.updateJobCategory = false
    },
    activeInactiveJobCategoryApiSuccess: (state, { payload }) => {
      state.jobCategoryListLoading = false
      state.updateJobCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload

      // if (payload?.payload?.data) {
      //   const updated = payload.payload.data
      //   state.jobCategoryList = state.jobCategoryList.map((item) =>
      //     item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
      //   )
      // }
    },
    activeInactiveJobCategoryApiFailed: (state, { payload }) => {
      state.jobCategoryListLoading = false
      state.ApiError = payload?.message
      state.updateJobCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Active / Inactive Job Sub Category
    activeInactiveJobSubCategoryApiData: (state) => {
      state.jobSubCategoryListLoading = true
      state.updateJobSubCategory = false
    },
    activeInactiveJobSubCategoryApiSuccess: (state, { payload }) => {
      state.jobSubCategoryListLoading = false
      state.updateJobSubCategory = true
      state.modalOpen = true
      state.ApiError = payload?.payload

      // if (payload?.payload?.data) {
      //   const updated = payload.payload.data
      //   state.jobSubCategoryList = state.jobSubCategoryList.map((item) =>
      //     item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
      //   )
      // }
    },
    activeInactiveJobSubCategoryApiFailed: (state, { payload }) => {
      state.jobSubCategoryListLoading = false
      state.ApiError = payload?.message
      state.updateJobSubCategory = false
      alert(JSON.stringify(payload, null, 2))
    },

    jobSeekerResumeListApiData: (state) => {
      state.jobSeekerResumeListLoading = true
    },

    jobSeekerResumeListApiSuccess: (state, { payload }) => {
      state.jobSeekerResumeListLoading = false
      state.jobSeekerResumeList = payload?.payload?.data || []

      state.jobSeekerResumePagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
      }
    },

    jobSeekerResumeListApiFailed: (state, { payload }) => {
      state.jobSeekerResumeListLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },

    jobSeekerResumeDetailsApiData: (state) => {
      state.jobSeekerResumeDetailsLoading = true
    },

    jobSeekerResumeDetailsApiSuccess: (state, { payload }) => {
      state.jobSeekerResumeDetailsLoading = false
      state.jobSeekerResumeDetails = payload?.payload
    },

    jobSeekerResumeDetailsApiFailed: (state, { payload }) => {
      state.jobSeekerResumeDetailsLoading = false
      state.ApiError = payload?.message
      alert(JSON.stringify(payload, null, 2))
    },

    // ✅ Job Details
    jobDetailsApiData: (state) => {
      state.jobDetailsLoading = true
    },

    jobDetailsApiSuccess: (state, { payload }) => {
      state.jobDetailsLoading = false
      state.jobDetails = payload?.payload
    },

    jobDetailsApiFailed: (state, { payload }) => {
      state.jobDetailsLoading = false
      state.ApiError = payload?.message
    },
    // ✅ Reset
    resetManageJobError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // Job Category
  jobCategoryListApiData,
  jobCategoryListApiSuccess,
  jobCategoryListApiFailed,
  addJobCategoryApiData,
  addJobCategoryApiSuccess,
  addJobCategoryApiFailed,
  updateJobCategoryApiData,
  updateJobCategoryApiSuccess,
  updateJobCategoryApiFailed,
  deleteJobCategoryApiData,
  deleteJobCategoryApiSuccess,
  deleteJobCategoryApiFailed,

  // Job Sub Category
  jobSubCategoryListApiData,
  jobSubCategoryListApiSuccess,
  jobSubCategoryListApiFailed,
  addJobSubCategoryApiData,
  addJobSubCategoryApiSuccess,
  addJobSubCategoryApiFailed,
  updateJobSubCategoryApiData,
  updateJobSubCategoryApiSuccess,
  updateJobSubCategoryApiFailed,
  deleteJobSubCategoryApiData,
  deleteJobSubCategoryApiSuccess,
  deleteJobSubCategoryApiFailed,

  // Job Tag
  jobTagListApiData,
  jobTagListApiSuccess,
  jobTagListApiFailed,
  jobTagByIdApiData,
  jobTagByIdApiSuccess,
  jobTagByIdApiFailed,
  addJobTagApiData,
  addJobTagApiSuccess,
  addJobTagApiFailed,
  updateJobTagApiData,
  updateJobTagApiSuccess,
  updateJobTagApiFailed,
  deleteJobTagApiData,
  deleteJobTagApiSuccess,
  deleteJobTagApiFailed,

  activeInactiveJobTagListApiData,
  activeInactiveJobTagListApiSuccess,
  activeInactiveJobTagListApiFailed,

  jobProviderListApiData,
  jobProviderListApiSuccess,
  jobProviderListApiFailed,

  jobSeekerAppliedListApiData,
  jobSeekerAppliedListApiSuccess,
  jobSeekerAppliedListApiFailed,

  storeJobListApiData,
  storeJobListApiSuccess,
  storeJobListApiFailed,

  storeJobApplicationListApiData,
  storeJobApplicationListApiSuccess,
  storeJobApplicationListApiFailed,

  activeInactiveJobCategoryApiData,
  activeInactiveJobCategoryApiSuccess,
  activeInactiveJobCategoryApiFailed,

  activeInactiveJobSubCategoryApiData,
  activeInactiveJobSubCategoryApiSuccess,
  activeInactiveJobSubCategoryApiFailed,

  jobSeekerResumeListApiData,
  jobSeekerResumeListApiSuccess,
  jobSeekerResumeListApiFailed,

  jobSeekerResumeDetailsApiData,
  jobSeekerResumeDetailsApiSuccess,
  jobSeekerResumeDetailsApiFailed,

  jobDetailsApiData,
  jobDetailsApiSuccess,
  jobDetailsApiFailed,

  // Reset
  resetManageJobError,
} = slice.actions

export default slice.reducer
